"use client";

import { useReportWebVitals } from "next/web-vitals";
import { sendToAnalytics } from "@/reportWebVitals";
export default function WebVitals() {
  useReportWebVitals(_temp);
  return null;
}
function _temp(metric) {
  return sendToAnalytics(metric);
}